function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgCrown = function SvgCrown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 511.925 511.925",
    style: {
      enableBackground: "new 0 0 511.925 511.925"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC107"
    },
    d: "M469.333,127.962c-23.564,0-42.667,19.103-42.667,42.667c0.009,4.473,0.729,8.916,2.133,13.163 l-34.603,21.995c-22.783,14.516-52.821,9.705-69.931-11.2l-33.92-41.493c5.398-7.267,8.316-16.078,8.32-25.131 c0-23.564-19.103-42.667-42.667-42.667s-42.667,19.103-42.667,42.667c0.004,9.053,2.922,17.864,8.32,25.131l-33.92,41.493 c-17.107,20.893-47.131,25.703-69.909,11.2L83.2,183.792c1.405-4.247,2.125-8.69,2.133-13.163 c0.004-23.564-19.095-42.67-42.66-42.674C19.11,127.951,0.004,147.051,0,170.615c-0.004,22.12,16.898,40.575,38.933,42.51 l25.216,151.253c0.855,5.143,5.303,8.915,10.517,8.917h362.667c5.214-0.002,9.662-3.774,10.517-8.917l25.216-151.253 c23.47-2.105,40.79-22.838,38.685-46.308C509.781,144.848,491.39,128.003,469.333,127.962z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFA000"
    },
    cx: 256,
    cy: 362.629,
    rx: 181.333,
    ry: 53.333
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD54F"
    },
    d: "M256,426.629c-95.424,0-192-21.973-192-64s96.576-64,192-64s192,21.973,192,64 S351.424,426.629,256,426.629z M256,319.962c-112.043,0-170.667,27.733-170.667,42.667S143.957,405.296,256,405.296 s170.667-27.733,170.667-42.667S368.043,319.962,256,319.962z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/crown.5c579925.svg";
export { ForwardRef as ReactComponent };